export const ListQueryKey = 'ranks';
export const DetailQueryKey = 'rank';

export const Urls = {
  selectUrl: '/rank/list',
  updateUrl: '/rank/update',
  deleteUrl: '/rank/delete',
  createUrl: '/rank/create',
  detailUrl: '/rank/detail',
  initlUrl: '/rank/init',
};
